module.exports = __webpack_public_path__ + "static/media/iris1.5d9731d8.jpeg";